module.exports = __webpack_public_path__ + "0c7e75779e43ff6d6f40156a3d5ff303.png";